@if (environment.test) {
    <div class="test">
        {{ compiledVersion.environment }} - {{ compiledVersion.datetime | date: 'EEE dd MMM yyyy HH:mm:ss' }} -
        {{ compiledVersion.buildNumber }}
    </div>
}
@if (parentUser) {
    <div class="parent-user" (click)="backToParentUser()">
        Je hebt als {{ parentUser?.name }} het account van {{ user?.name }} overgenomen. Klik hier om terug te gaan naar
        je eigen account.
    </div>
}
<div class="d-flex flex-column" [class.vh-100]="!print">
    @if (showToolbox && toolbox) {
        <div class="toolbox" [class.warn]="toolboxWarn" (click)="viewToolbox()">
            @if (toolboxWarn) {
                <div>Bekijk nu de toolbox van {{ toolbox.begindate | date: 'EEE dd MMMM' }}.</div>
            } @else if (!toolboxWarn) {
                <div>
                    Bekijk de toolbox van {{ toolbox.begindate | date: 'EEE dd MMMM' }} voor
                    {{ toolbox.view_before | date: 'EEE dd MMMM' }}.
                </div>

                <button class="hide" (click)="close()" mat-icon-button>
                    <mat-icon class="fas fa-times"></mat-icon>
                </button>
            }
        </div>
    }
    <div class="flex-fill overflow-auto position-relative" id="main-container" [class.overflow-auto]="!print">
        <router-outlet></router-outlet>
    </div>
</div>
